import React                from 'react';
import colors               from '../../utils/colors';
import BackspaceRoundedIcon from '@material-ui/icons/BackspaceRounded';
import { makeStyles }       from '@material-ui/core/styles';

var clsx = require('classnames')

const arr = new Array(10).fill(0).map((val, ind) => { return `${ ind + 1 }` }).concat(['+', '-', '=', 'backspace'])

const useStyles = makeStyles(() => ({
    root: {
        position:       'fixed',
        width:          '100vw',
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        flexFlow:       'column',
        transition:     'all 0.4s',
        zIndex:         999
    },
    grid: {
        marginTop:            15,
        height:               150,
        width:                500,
        maxWidth:             '90vw',
        display:              'grid',
        gridTemplateColumns: `repeat(7, 1fr)`,
    },
    flex: {
       marginTop:      -100,
       height:         100,
       width:          '100vw',
       display:        'flex',
       alignItems:     'center',
       justifyContent: 'center',
       flexFlow:       'row',
       transition:     'all 0.3s'
    },
    unit: {
       cursor:          'pointer',
       display:         'flex',
       alignItems:      'center',
       justifyContent:  'center',
       color:           '#FFF',
       borderRadius:    '0.5em',
       border:          '1px solid #FFF',
       backgroundColor: colors.blue
    },
    erase: {
        backgroundColor: '#E56'
      // width: '200%'
    },
    icon: {
       color: '#FFF'
    },
    operator: {
       backgroundColor: colors.darkGreen,
       fontSize:        23,
    },
    text: {
        color:     colors.blue,
        fontSize:  30,
        textAlign: 'center'
    },
    button: {
        position:        'absolute',
        height:          40,
        width:           140,
        fontSize:        20,
        top:             50,
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        textAlign:       'center',
        borderRadius:    '0.5em',
        backgroundColor: colors.blue,
        color:           '#FFF',
        transform:       'translate(0px, -100px)'
    }
}))

type GridProps = {
    size:             number[];
    target_size:      number;
    selectedInputBox: number;
    stage1complete:   boolean;
    disableButton:    boolean;
    handleClick:      (val: string) => void;
    handleSubmition:  () => void;
}

const Grid: React.FC<GridProps> = ({ 
    size,
    target_size,
    stage1complete,
    selectedInputBox,
    disableButton,
    handleClick,
    handleSubmition
 }) => {

 const classes = useStyles();

// const [selectedBox, setSelectedBox] = React.useState(0) 


const selectedBox = React.useMemo(() => {
   return selectedInputBox
},[selectedInputBox])

  return (
      <div 
        className = { classes.root }
        style     = {{
            top:       (size[1]/2) + target_size/4 + 20,
            transform: `translate(0px, ${ stage1complete ? 100 : 0 }vh)`
        }}
      >
        <div
            dir        = "rtl"
            className = { classes.button }
            onClick   = { () => { if (disableButton) { return }; handleSubmition() }}
            style     = {{
                opacity:   disableButton ? 0.2 : 1,
                cursor:    disableButton ? 'default' : 'pointer',
            }}
        >
            אישור
        </div>
        <div className = { classes.grid }>
            {
                arr.map((val, ind) => {

                    const iAmOperator  = ind >= 10 && ind <= 12;
                    const iAmBackSpace = ind === arr.length - 1;
                    const disable = ((selectedBox === 1 && val !== '+' && !iAmBackSpace) || (selectedBox !== 1 && iAmOperator));

                    return (
                        <div 
                           key       = { `exercises_solutions${ ind }` }
                           className = { iAmOperator ? clsx(classes.unit, classes.operator) : iAmBackSpace ? clsx(classes.unit, classes.erase) : classes.unit }
                           onClick   = { () => { if (disable) { return }; handleClick(val) }}
                           style     = {{
                              opacity: disable ? 0.2 : 1,
                              cursor:  disable ? 'default' : 'pointer'
                        }}
                        >
                           { ind < arr.length - 1 ? val : <BackspaceRoundedIcon className = { classes.icon }/> }
                        </div>
                    )
                })
            }
        </div>
    </div>
  );
}



export default Grid;








